import { ActivityBuilderPrintPictureStatic } from './activity-builder-print-image.style';

export const ActivityBuilderPrintStaticImage = ({
  imageUrl,
  altText,
  imageDimensions,
  ...rest
}: {
  imageUrl: string;
  altText?: string;
  imageDimensions?: { width: number; height: number };
}) => {
  return (
    <ActivityBuilderPrintPictureStatic>
      <img
        src={imageUrl}
        alt={altText}
        style={
          imageDimensions
            ? {
                width: imageDimensions.width,
                height: imageDimensions.height,
              }
            : undefined
        }
        {...rest}
      />
    </ActivityBuilderPrintPictureStatic>
  );
};
